import getBancosService from './getBancosService'
import getBiometricsValidateAppService from './getBiometricsValidateAppService'
import getBiometricsValidateWebService from './getBiometricsValidateWebService'
import getCaptureDocumentsService from './getCaptureDocumentsService'
import getContratosService from './getContratosService'
import getDadosPessoaisService from './getDadosPessoaisService'
import getDadosPropostaService from './getDadosPropostaService'
import getEnderecoService from './getEnderecoService'
import getPropostasService from './getPropostasService'
import getSignatureDocumentsService from './getSignatureDocumentsService'
import getSimulacaoPropostaService from './getSimulacaoPropostaService'
import getSimulacaoRefinanciamentoService from './getSimulacaoRefinanciamentoService'
import postAutorizacaoISafeService from './postAutorizacaoISafeService'
import postBiometriaDadosAppService from './postBiometriaDadosAppService'
import postBiometriaDadosWebService from './postBiometriaDadosWebService'
import postCaptureDocumentsService from './postCaptureDocumentsService'
import postContractMarginAcceptService from './postContractMarginAcceptService'
import postContractMarginResultService from './postContractMarginResultService'
import postContratacaoService from './postContratacaoService'
import postDadosPessoaisService from './postDadosPessoaisService'
import postDadosPropostaService from './postDadosPropostaService'
import postSignatureDocumentsService from './postSignatureDocumentsService'
import postEnviarDocumentosAppService from './postEnviarDocumentosAppService'
import postEnviarDocumentosWebService from './postEnviarDocumentosWebService'
import postPropostaFinalizarAppService from './postPropostaFinalizarAppService'
import postPropostaFinalizarWebService from './postPropostaFinalizarWebService'
import postRefinancingBeginService from './postRefinancingBeginService'
import postTrackingRefinService from './postTrackingRefinService'
import getAuthenticationService from './getAuthenticationService'
import getParameter from './getParameter'
import getBiometricActive from './getBiometricActive'
import getUseNewProviders from './getUseNewProviders'
import getSeed from './getSeed'
import postGenerateIdUnicoLink from './postGenerateIdUnicoLink'
import postValidateBiometricsAppService from './postValidateBiometricsAppService'
import postValidateBiometricsWebService from './postValidateBiometricsWebService'

export default {
  getBancosService,
  getBiometricsValidateAppService,
  getBiometricsValidateWebService,
  getCaptureDocumentsService,
  getContratosService,
  getDadosPessoaisService,
  getDadosPropostaService,
  getEnderecoService,
  getPropostasService,
  getSignatureDocumentsService,
  getSimulacaoPropostaService,
  getSimulacaoRefinanciamentoService,
  postAutorizacaoISafeService,
  postBiometriaDadosAppService,
  postBiometriaDadosWebService,
  postCaptureDocumentsService,
  postContractMarginAcceptService,
  postContractMarginResultService,
  postContratacaoService,
  postDadosPessoaisService,
  postDadosPropostaService,
  postSignatureDocumentsService,
  postEnviarDocumentosAppService,
  postEnviarDocumentosWebService,
  postPropostaFinalizarAppService,
  postPropostaFinalizarWebService,
  postRefinancingBeginService,
  postTrackingRefinService,
  getAuthenticationService,
  getParameter,
  getBiometricActive,
  getUseNewProviders,
  getSeed,
  postGenerateIdUnicoLink,
  postValidateBiometricsAppService,
  postValidateBiometricsWebService,
}
